import { InputItem } from "./InputItem";

export default InputItem;
